import * as React from 'react';
import { SVGProps } from 'react';

const IconDrillingPartLeftFilledSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15 8c0-3.563-2.62-6.51-6.03-7v14c3.41-.49 6.03-3.437 6.03-7ZM6.96 9.01V15C3.877 14.557 1.44 12.107 1 9.01h5.96ZM1 6.99C1.44 3.893 3.878 1.443 6.96 1v5.99H1Z" />
  </svg>
);
export default IconDrillingPartLeftFilledSizeS;
